import { Fraction } from "./types";

const gcd = function (a: number, b: number) {
  if (!b) {
    return a;
  }

  return gcd(b, a % b);
};

export const frac = (number: number): Fraction => {
  const whole = Math.floor(number);
  const decimal = number % 1;
  const numerator = Math.round(decimal * 16);
  const commonDenominator = gcd(numerator, 16);
  const reducedNumerator = numerator / commonDenominator;
  const denominator = 16 / commonDenominator;

  if (reducedNumerator === 1 && denominator === 1) {
    return [whole + 1, 0, 16];
  }

  return [whole, reducedNumerator, denominator];
};
